'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.RoutablePage = void 0;
var RoutablePage;
(function (RoutablePage) {
    RoutablePage[RoutablePage["HOME"] = 0] = "HOME";
    RoutablePage[RoutablePage["SIGN_UP"] = 1] = "SIGN_UP";
    RoutablePage[RoutablePage["SIGN_UP_BANKID"] = 2] = "SIGN_UP_BANKID";
    RoutablePage[RoutablePage["SIGN_UP_DONE"] = 3] = "SIGN_UP_DONE";
    RoutablePage[RoutablePage["PASS_RESET_REQUEST"] = 4] = "PASS_RESET_REQUEST";
    RoutablePage[RoutablePage["PASS_RESET_CONFIRMATION"] = 5] = "PASS_RESET_CONFIRMATION";
    RoutablePage[RoutablePage["PASS_RESET_CONFIRMATION_DONE"] = 6] = "PASS_RESET_CONFIRMATION_DONE";
    RoutablePage[RoutablePage["PASS_RESET_SUCCESS"] = 7] = "PASS_RESET_SUCCESS";
    RoutablePage[RoutablePage["LOG_IN"] = 8] = "LOG_IN";
    RoutablePage[RoutablePage["LOG_IN_DONE"] = 9] = "LOG_IN_DONE";
    RoutablePage[RoutablePage["GAMEPLAY"] = 10] = "GAMEPLAY";
    RoutablePage[RoutablePage["GAMEPLAY_DONE"] = 11] = "GAMEPLAY_DONE";
    RoutablePage[RoutablePage["ACCOUNT"] = 12] = "ACCOUNT";
    RoutablePage[RoutablePage["PROFILE"] = 13] = "PROFILE";
    RoutablePage[RoutablePage["CHANGE_EMAIL"] = 14] = "CHANGE_EMAIL";
    RoutablePage[RoutablePage["CHANGE_PASSWORD"] = 15] = "CHANGE_PASSWORD";
    RoutablePage[RoutablePage["CHANGE_SECURITY_QUESTION"] = 16] = "CHANGE_SECURITY_QUESTION";
    RoutablePage[RoutablePage["MARKETING_PREFERENCES"] = 17] = "MARKETING_PREFERENCES";
    RoutablePage[RoutablePage["ACCOUNT_CLOSURE"] = 18] = "ACCOUNT_CLOSURE";
    RoutablePage[RoutablePage["ACCOUNT_CLOSURE_FORM"] = 19] = "ACCOUNT_CLOSURE_FORM";
    RoutablePage[RoutablePage["ACCOUNT_CLOSURE_SUCCESS"] = 20] = "ACCOUNT_CLOSURE_SUCCESS";
    RoutablePage[RoutablePage["ACCOUNT_CLOSURE_ERROR"] = 21] = "ACCOUNT_CLOSURE_ERROR";
    RoutablePage[RoutablePage["ACCOUNT_CLOSURE_DONE"] = 22] = "ACCOUNT_CLOSURE_DONE";
    RoutablePage[RoutablePage["WITHDRAW"] = 23] = "WITHDRAW";
    RoutablePage[RoutablePage["RESPONSIBLE_GAMING"] = 24] = "RESPONSIBLE_GAMING";
    RoutablePage[RoutablePage["RESPONSIBLE_GAMING_PAGE"] = 25] = "RESPONSIBLE_GAMING_PAGE";
    RoutablePage[RoutablePage["VIEW_LIMITS"] = 26] = "VIEW_LIMITS";
    RoutablePage[RoutablePage["CREATE_LIMITS"] = 27] = "CREATE_LIMITS";
    RoutablePage[RoutablePage["SELF_EXCLUDE"] = 28] = "SELF_EXCLUDE";
    RoutablePage[RoutablePage["PANIC_SELF_EXCLUDE"] = 29] = "PANIC_SELF_EXCLUDE";
    RoutablePage[RoutablePage["TIME_OUT"] = 30] = "TIME_OUT";
    RoutablePage[RoutablePage["MESSAGES"] = 31] = "MESSAGES";
    RoutablePage[RoutablePage["MESSAGE"] = 32] = "MESSAGE";
    RoutablePage[RoutablePage["VERIFICATION"] = 33] = "VERIFICATION";
    RoutablePage[RoutablePage["SOW"] = 34] = "SOW";
    RoutablePage[RoutablePage["USER_INFO"] = 35] = "USER_INFO";
    RoutablePage[RoutablePage["NOT_FOUND"] = 36] = "NOT_FOUND";
    RoutablePage[RoutablePage["LIVE_CHAT"] = 37] = "LIVE_CHAT";
    RoutablePage[RoutablePage["WALLET_DEPOSIT"] = 38] = "WALLET_DEPOSIT";
    RoutablePage[RoutablePage["WALLET_HISTORY"] = 39] = "WALLET_HISTORY";
    RoutablePage[RoutablePage["WALLET_HISTORY_GAMING"] = 40] = "WALLET_HISTORY_GAMING";
    RoutablePage[RoutablePage["WALLET_BONUS"] = 41] = "WALLET_BONUS";
    RoutablePage[RoutablePage["WALLET_WITHDRAW"] = 42] = "WALLET_WITHDRAW";
    RoutablePage[RoutablePage["REWARD_DETAIL"] = 43] = "REWARD_DETAIL";
    RoutablePage[RoutablePage["REWARDS"] = 44] = "REWARDS";
    RoutablePage[RoutablePage["OFFER"] = 45] = "OFFER";
    RoutablePage[RoutablePage["PROMOTION"] = 46] = "PROMOTION";
    RoutablePage[RoutablePage["PROMOTIONS"] = 47] = "PROMOTIONS";
    RoutablePage[RoutablePage["GAMES"] = 48] = "GAMES";
    RoutablePage[RoutablePage["SEARCH"] = 49] = "SEARCH";
    RoutablePage[RoutablePage["FAQ"] = 50] = "FAQ";
    RoutablePage[RoutablePage["FAQ_CATEGORY"] = 51] = "FAQ_CATEGORY";
    RoutablePage[RoutablePage["REALITY_CHECK"] = 52] = "REALITY_CHECK";
    RoutablePage[RoutablePage["SPORTSBOOK"] = 53] = "SPORTSBOOK";
    RoutablePage[RoutablePage["SPORTSBOOK_INTERNAL"] = 54] = "SPORTSBOOK_INTERNAL";
    RoutablePage[RoutablePage["PASS_RESET_SECURITY_QUESTION"] = 55] = "PASS_RESET_SECURITY_QUESTION";
    RoutablePage[RoutablePage["LEADERBOARDS"] = 56] = "LEADERBOARDS";
    RoutablePage[RoutablePage["TOURNAMENTS"] = 57] = "TOURNAMENTS";
    RoutablePage[RoutablePage["TOURNAMENTS_STARTING_SOON"] = 58] = "TOURNAMENTS_STARTING_SOON";
    RoutablePage[RoutablePage["TOURNAMENTS_HISTORY"] = 59] = "TOURNAMENTS_HISTORY";
    RoutablePage[RoutablePage["PASS_RESET_EMAIL"] = 60] = "PASS_RESET_EMAIL";
    RoutablePage[RoutablePage["PASS_RESET_SMS"] = 61] = "PASS_RESET_SMS";
    RoutablePage[RoutablePage["LIVE_CASINO"] = 62] = "LIVE_CASINO";
    RoutablePage[RoutablePage["ACCOUNT_CUSTOM_ITEM"] = 63] = "ACCOUNT_CUSTOM_ITEM";
    RoutablePage[RoutablePage["TWO_FACTOR_AUTHENTICATION"] = 64] = "TWO_FACTOR_AUTHENTICATION";
    RoutablePage[RoutablePage["SIGN_UP_HYBRID"] = 65] = "SIGN_UP_HYBRID";
    RoutablePage[RoutablePage["LOTBA_OLD_SELF_EXCLUSION_LINK"] = 66] = "LOTBA_OLD_SELF_EXCLUSION_LINK";
    RoutablePage[RoutablePage["PLAY_CONTROL"] = 67] = "PLAY_CONTROL";
    RoutablePage[RoutablePage["LANDING"] = 68] = "LANDING";
    RoutablePage[RoutablePage["LANDING_SIGNUP"] = 69] = "LANDING_SIGNUP";
    RoutablePage[RoutablePage["QUESTIONNAIRES"] = 70] = "QUESTIONNAIRES";
    RoutablePage[RoutablePage["FREE_TO_PLAY"] = 71] = "FREE_TO_PLAY";
    RoutablePage[RoutablePage["PROMOTION_PLAY"] = 72] = "PROMOTION_PLAY";
    RoutablePage[RoutablePage["SET_LIMITS"] = 73] = "SET_LIMITS";
    RoutablePage[RoutablePage["BINGO_LOBBY"] = 74] = "BINGO_LOBBY";
    RoutablePage[RoutablePage["PERSONALISED_OFFER"] = 75] = "PERSONALISED_OFFER";
    RoutablePage[RoutablePage["SWEEPSTAKES_SHOP"] = 76] = "SWEEPSTAKES_SHOP";
    RoutablePage[RoutablePage["SWEEPSTAKES_REDEEM"] = 77] = "SWEEPSTAKES_REDEEM";
    RoutablePage[RoutablePage["TNC"] = 78] = "TNC";
    RoutablePage[RoutablePage["PROVIDERS"] = 79] = "PROVIDERS";
    RoutablePage[RoutablePage["FREE_TO_PLAY_LOBBY"] = 80] = "FREE_TO_PLAY_LOBBY";
    RoutablePage[RoutablePage["FREE_TO_PLAY_HOMEPAGE"] = 81] = "FREE_TO_PLAY_HOMEPAGE";
    RoutablePage[RoutablePage["FREE_TO_PLAY_LOBBY_GAMEPLAY"] = 82] = "FREE_TO_PLAY_LOBBY_GAMEPLAY";
    RoutablePage[RoutablePage["STREAMING_LOBBY"] = 83] = "STREAMING_LOBBY";
    RoutablePage[RoutablePage["PERIODIC_ACCOUNT_REVIEW"] = 84] = "PERIODIC_ACCOUNT_REVIEW";
})(RoutablePage = exports.RoutablePage || (exports.RoutablePage = {}));
